import React, { useState } from 'react';
import ModalContext from './ModalContext';
import { IModalProviderState } from './types';

const initialState: IModalProviderState = {
  component: null,
  props: null,
};

const ModalProvider: React.FC = ({ children }) => {
  const [state, setState] = useState<IModalProviderState>(initialState);

  return (
    <ModalContext.Provider
      value={{
        ...state,
        showModal: (component, props) => setState({ component, props }),
        hideModal: () => setState(initialState),
      }}
    >
      {children}
    </ModalContext.Provider>
  );
};

export default ModalProvider;
